import { useVersion } from "@/composables/version";
import { type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";

export const checkVersion = async (to: RouteLocationNormalized, _: RouteLocationNormalized, next: NavigationGuardNext) => {
  const { isLatest } = useVersion();
  if (!isLatest.value) {
    window.location.href = to.fullPath;
    return;
  }
  return next();
};
